import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
// window.jQuery = $;
// require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';

$(document).foundation();

// Show scroll to top button on scroll
window.onscroll = function () {
    if (document.body.scrollTop > 30 || this.document.documentElement.scrollTop > 30) {
        $('#ToTopButton')[0].style.display = 'block'
    } else {
        $('#ToTopButton')[0].style.display = 'none'
    }
}

//#region Nav Icon 
$('#offCanvasRight').on('opened.zf.offCanvas', function () {
    var menIcon = $('#nav-icon')[0];
    var closeIcon = $('#closeIcon')[0];
    menIcon.style.display = "none";
    closeIcon.style.display = "block";
});

$('#offCanvasRight').on('closed.zf.offCanvas', function () {
    console.log('piepo')
    var menIcon = $('#nav-icon')[0];
    var closeIcon = $('#closeIcon')[0];
    closeIcon.style.display = "none";
    menIcon.style.display = "block";
});

$('#closeIcon').on('click', function () {
    $('#offCanvasRight').foundation('toggle');
    var menIcon = $('#nav-icon')[0];
    var closeIcon = $('#closeIcon')[0];
    closeIcon.style.display = "none";
    menIcon.style.display = "block";
});
//#endregion

// Switchbox on Index & About Us & Career
var switchBox = $('.imgBlock');
switchBox.on('click', function () {
    if ($(this)[0].dataset.site == "about") {
        var front = $('#frontAbout');
        var back = $('#backAbout');

        if (back.hasClass('currentFront')) {
            back[0].style.zIndex = "0"
            back.removeClass('currentFront')
        } else if (front.hasClass('isFront')) {
            back.addClass('currentFront')
            back[0].style.zIndex = "10";
        }
    } else if ($(this)[0].dataset.site == "career") {
        var front = $('#frontCareer');
        var back = $('#backCareer');

        if (back.hasClass('currentFront')) {
            back[0].style.zIndex = "0"
            back.removeClass('currentFront')
        } else if (front.hasClass('isFront')) {
            back.addClass('currentFront')
            back[0].style.zIndex = "10";
        }
    } else {
        var front = $('#front');
        var back = $('#back');

        if (back.hasClass('currentFront')) {
            back[0].style.zIndex = "0"
            back.removeClass('currentFront')
        } else if (front.hasClass('isFront')) {
            back.addClass('currentFront')
            back[0].style.zIndex = "10";
        }
    }
});

// Customer Pictures Collapsible 
$('#OpenCustomerCollapse').on('click', function () {
    var collaps = $('.collapsibleCustomers');
    console.log(collaps);
    if (!collaps[0].classList.contains('active')) {
        collaps.addClass('active');
        $(this)[0].innerText = '-'
    } else if (collaps[0].classList.contains('active')) {
        // $('#plusMinusIcon')[0].style.display = "";
        collaps.removeClass('active');
        $(this)[0].innerText = '+'
    }
});

//Wide Open Accordion on CRM part open
$('#OpenCRMAcc').on('down.zf.accordion up.zf.accordion', function () {
    $('.openCRM').on('click', function () {
        var cont = $('#crmopenbig');
        if (cont.hasClass('active')) {
            cont.removeClass('active');
        } else {
            cont.addClass('active');
        }
    });
})

//#region Home Spoiler Workshops/Vortraege/Messen
var boxOpen = false;
$('#OpenSpoilerBox1').on('click', function () {
    var collaps = $('#SpoilerB1');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile1 .tile-content').addClass('active');
        $('#SpoilerTile1 .tile-title').addClass('active');
        $('#SpoilerTile1 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile1 .tile-links').removeClass('active');
        $('#SpoilerTile1 .tile-content').removeClass('active');
        $('#SpoilerTile1 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox2').on('click', function () {
    var collaps = $('#SpoilerB2');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile2 .tile-content').addClass('active');
        $('#SpoilerTile2 .tile-title').addClass('active');
        $('#SpoilerTile2 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile2 .tile-links').removeClass('active');
        $('#SpoilerTile2 .tile-content').removeClass('active');
        $('#SpoilerTile2 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox3').on('click', function () {
    var collaps = $('#SpoilerB3');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile3 .tile-content').addClass('active');
        $('#SpoilerTile3 .tile-title').addClass('active');
        $('#SpoilerTile3 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile3 .tile-links').removeClass('active');
        $('#SpoilerTile3 .tile-content').removeClass('active');
        $('#SpoilerTile3 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox4').on('click', function () {
    var collaps = $('#SpoilerB4');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile4 .tile-content').addClass('active');
        $('#SpoilerTile4 .tile-title').addClass('active');
        $('#SpoilerTile4 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile4 .tile-links').removeClass('active');
        $('#SpoilerTile4 .tile-content').removeClass('active');
        $('#SpoilerTile4 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox5').on('click', function () {
    var collaps = $('#SpoilerB5');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile5 .tile-content').addClass('active');
        $('#SpoilerTile5 .tile-title').addClass('active');
        $('#SpoilerTile5 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile5 .tile-links').removeClass('active');
        $('#SpoilerTile5 .tile-content').removeClass('active');
        $('#SpoilerTile5 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox6').on('click', function () {
    var collaps = $('#SpoilerB6');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile6 .tile-content').addClass('active');
        $('#SpoilerTile6 .tile-title').addClass('active');
        $('#SpoilerTile6 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile6 .tile-links').removeClass('active');
        $('#SpoilerTile6 .tile-content').removeClass('active');
        $('#SpoilerTile6 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox7').on('click', function () {
    var collaps = $('#SpoilerB7');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile7 .tile-content').addClass('active');
        $('#SpoilerTile7 .tile-title').addClass('active');
        $('#SpoilerTile7 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile7 .tile-links').removeClass('active');
        $('#SpoilerTile7 .tile-content').removeClass('active');
        $('#SpoilerTile7 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox8').on('click', function () {
    var collaps = $('#SpoilerB8');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile8 .tile-content').addClass('active');
        $('#SpoilerTile8 .tile-title').addClass('active');
        $('#SpoilerTile8 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile8 .tile-links').removeClass('active');
        $('#SpoilerTile8 .tile-content').removeClass('active');
        $('#SpoilerTile8 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox9').on('click', function () {
    var collaps = $('#SpoilerB9');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile9 .tile-content').addClass('active');
        $('#SpoilerTile9 .tile-title').addClass('active');
        $('#SpoilerTile9 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile9 .tile-links').removeClass('active');
        $('#SpoilerTile9 .tile-content').removeClass('active');
        $('#SpoilerTile9 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox10').on('click', function () {
    var collaps = $('#SpoilerB10');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile10 .tile-content').addClass('active');
        $('#SpoilerTile10 .tile-title').addClass('active');
        $('#SpoilerTile10 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile10 .tile-links').removeClass('active');
        $('#SpoilerTile10 .tile-content').removeClass('active');
        $('#SpoilerTile10 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox11').on('click', function () {
    var collaps = $('#SpoilerB11');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile11 .tile-content').addClass('active');
        $('#SpoilerTile11 .tile-title').addClass('active');
        $('#SpoilerTile11 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile11 .tile-links').removeClass('active');
        $('#SpoilerTile11 .tile-content').removeClass('active');
        $('#SpoilerTile11 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox12').on('click', function () {
    var collaps = $('#SpoilerB12');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile12 .tile-content').addClass('active');
        $('#SpoilerTile12 .tile-title').addClass('active');
        $('#SpoilerTile12 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile12 .tile-links').removeClass('active');
        $('#SpoilerTile12 .tile-content').removeClass('active');
        $('#SpoilerTile12 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }

});

$('#OpenSpoilerBox13').on('click', function () {
    var collaps = $('#SpoilerB13');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile13 .tile-content').addClass('active');
        $('#SpoilerTile13 .tile-title').addClass('active');
        $('#SpoilerTile13 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile13 .tile-links').removeClass('active');
        $('#SpoilerTile13 .tile-content').removeClass('active');
        $('#SpoilerTile13 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox14').on('click', function () {
    var collaps = $('#SpoilerB14');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile14 .tile-content').addClass('active');
        $('#SpoilerTile14 .tile-title').addClass('active');
        $('#SpoilerTile14 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile14 .tile-links').removeClass('active');
        $('#SpoilerTile14 .tile-content').removeClass('active');
        $('#SpoilerTile14 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox15').on('click', function () {
    var collaps = $('#SpoilerB15');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile15 .tile-content').addClass('active');
        $('#SpoilerTile15 .tile-title').addClass('active');
        $('#SpoilerTile15 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile15 .tile-links').removeClass('active');
        $('#SpoilerTile15 .tile-content').removeClass('active');
        $('#SpoilerTile15 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox16').on('click', function () {
    var collaps = $('#SpoilerB16');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile16 .tile-content').addClass('active');
        $('#SpoilerTile16 .tile-title').addClass('active');
        $('#SpoilerTile16 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile16 .tile-links').removeClass('active');
        $('#SpoilerTile16 .tile-content').removeClass('active');
        $('#SpoilerTile16 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox17').on('click', function () {
    var collaps = $('#SpoilerB17');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile17 .tile-content').addClass('active');
        $('#SpoilerTile17 .tile-title').addClass('active');
        $('#SpoilerTile17 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile17 .tile-links').removeClass('active');
        $('#SpoilerTile17 .tile-content').removeClass('active');
        $('#SpoilerTile17 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox18').on('click', function () {
    var collaps = $('#SpoilerB18');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile18 .tile-content').addClass('active');
        $('#SpoilerTile18 .tile-title').addClass('active');
        $('#SpoilerTile18 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile18 .tile-links').removeClass('active');
        $('#SpoilerTile18 .tile-content').removeClass('active');
        $('#SpoilerTile18 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenSpoilerBox19').on('click', function () {
    var collaps = $('#SpoilerB19');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#SpoilerTile19 .tile-content').addClass('active');
        $('#SpoilerTile19 .tile-title').addClass('active');
        $('#SpoilerTile19 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "700px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#SpoilerTile19 .tile-links').removeClass('active');
        $('#SpoilerTile19 .tile-content').removeClass('active');
        $('#SpoilerTile19 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});
//#endregion

//#region About Us Herzensprojekte & Karriere Stellenausschreibungen
$('#openBox1').on('click', function () {
    var collaps = $('#b1');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#tile1 .tile-content').addClass('active');
        $('#tile1 .tile-title').addClass('active');
        $('#tile1 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "900px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#tile1 .tile-links').removeClass('active');
        $('#tile1 .tile-content').removeClass('active');
        $('#tile1 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#openBox2').on('click', function () {
    var collaps = $('#b2');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#tile2 .tile-content').addClass('active');
        $('#tile2 .tile-title').addClass('active');
        $('#tile2 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "900px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#tile2 .tile-links').removeClass('active');
        $('#tile2 .tile-content').removeClass('active');
        $('#tile2 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#openBox3').on('click', function () {
    var collaps = $('#b3');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#tile3 .tile-content').addClass('active');
        $('#tile3 .tile-title').addClass('active');
        $('#tile3 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "900px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#tile3 .tile-links').removeClass('active');
        $('#tile3 .tile-content').removeClass('active');
        $('#tile3 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#openBox4').on('click', function () {
    var collaps = $('#b4');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#tile4 .tile-content').addClass('active');
        $('#tile4 .tile-title').addClass('active');
        $('#tile4 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "900px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#tile4 .tile-links').removeClass('active');
        $('#tile4 .tile-content').removeClass('active');
        $('#tile4 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});


$('#openBox5').on('click', function () {
    var collaps = $('#b5');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#tile5 .tile-content').addClass('active');
        $('#tile5 .tile-title').addClass('active');
        $('#tile5 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "900px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#tile5 .tile-links').removeClass('active');
        $('#tile5 .tile-content').removeClass('active');
        $('#tile5 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#openBox6').on('click', function () {
    var collaps = $('#b6');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#tile6 .tile-content').addClass('active');
        $('#tile6 .tile-title').addClass('active');
        $('#tile6 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "900px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#tile6 .tile-links').removeClass('active');
        $('#tile6 .tile-content').removeClass('active');
        $('#tile6 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#openBox7').on('click', function () {
    var collaps = $('#b7');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#tile7 .tile-content').addClass('active');
        $('#tile7 .tile-title').addClass('active');
        $('#tile7 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "900px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#tile7 .tile-links').removeClass('active');
        $('#tile7 .tile-content').removeClass('active');
        $('#tile7 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#openBox8').on('click', function () {
    var collaps = $('#b8');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#tile8 .tile-content').addClass('active');
        $('#tile8 .tile-title').addClass('active');
        $('#tile8 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "900px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#tile8 .tile-links').removeClass('active');
        $('#tile8 .tile-content').removeClass('active');
        $('#tile8 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});


$('#openBox9').on('click', function () {
    var collaps = $('#b9');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#tile9 .tile-content').addClass('active');
        $('#tile9 .tile-title').addClass('active');
        $('#tile9 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "900px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#tile9 .tile-links').removeClass('active');
        $('#tile9 .tile-content').removeClass('active');
        $('#tile9 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});


$('#openBox10').on('click', function () {
    var collaps = $('#b10');
    if (!$(this).hasClass('active')) {
        if (boxOpen == true) {
            $('.tile-links').removeClass('active');
            $('.tile-content').removeClass('active');
            $('.tile-title').removeClass('active');
            $('.openBox').removeClass('active');
        }
        boxOpen = true;
        collaps.addClass('active');
        $('#tile10 .tile-content').addClass('active');
        $('#tile10 .tile-title').addClass('active');
        $('#tile10 .tile-links').addClass('active');
        collaps[0].style.maxHeight = "900px";
    } else {
        collaps[0].style.maxHeight = "50px";
        $('#tile10 .tile-links').removeClass('active');
        $('#tile10 .tile-content').removeClass('active');
        $('#tile10 .tile-title').removeClass('active');
        collaps.removeClass('active');
    }
});
//#endregion

//#region Company Info About Us
$('#OpenCompanyBox1').on('click', function () {
    var collaps = $('#CompanyB1');
    if (!collaps[0].classList.contains('active')) {
        collaps.addClass('active');
        $('#CompanyTile1 .company-tile-content').addClass('active');
        $('#CompanyTile1 .title-company').addClass('active');
        $('#CompanyTile1 .open-container').addClass('active');
    } else if (collaps[0].classList.contains('active')) {
        $('#CompanyTile1 .company-tile-content').removeClass('active');
        $('#CompanyTile1 .title-company').removeClass('active');
        $('#CompanyTile1 .open-container').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenCompanyBox2').on('click', function () {
    var collaps = $('#CompanyB2');
    if (!collaps[0].classList.contains('active')) {
        collaps.addClass('active');
        $('#CompanyTile2 .company-tile-content').addClass('active');
        $('#CompanyTile2 .title-company').addClass('active');
        $('#CompanyTile2 .open-container').addClass('active');
    } else if (collaps[0].classList.contains('active')) {
        $('#CompanyTile2 .company-tile-content').removeClass('active');
        $('#CompanyTile2 .title-company').removeClass('active');
        $('#CompanyTile2 .open-container').removeClass('active');
        collaps.removeClass('active');
    }
});

$('#OpenCompanyBox3').on('click', function () {
    var collaps = $('#CompanyB3');
    if (!collaps[0].classList.contains('active')) {
        collaps.addClass('active');
        $('#CompanyTile3 .company-tile-content').addClass('active');
        $('#CompanyTile3 .title-company').addClass('active');
        $('#CompanyTile3 .open-container').addClass('active');
    } else if (collaps[0].classList.contains('active')) {
        $('#CompanyTile3 .company-tile-content').removeClass('active');
        $('#CompanyTile3 .title-company').removeClass('active');
        $('#CompanyTile3 .open-container').removeClass('active');
        collaps.removeClass('active');
    }
});
//#endregion